import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Software from "./pages/Software";
import Pricing from "./pages/Pricing";
import WhyUs from "./pages/WhyUs";
import FAQ from "./pages/FAQ";
import Contact from "./pages/Contact";
import AdminApp from "./pages/AdminApp";
import MemberApp from "./pages/MemberApp";
import Kiosk from "./pages/Kiosk";
import TapPayApp from "./pages/TapPayApp";
import MobilePos from "./pages/MobilePos";
import PrivacyPolicy from "./pages/PrivacyPolicy";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/software" element={<Software />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/why-us" element={<WhyUs />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin-app" element={<AdminApp />} />
            <Route path="/member-app" element={<MemberApp />} />
            <Route path="/kiosk" element={<Kiosk />} />
            <Route path="/tap-and-pay" element={<TapPayApp />} />
            <Route path="/mobile-pos" element={<MobilePos />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
